import React from 'react';
import classNames from 'classnames';

import DefaultLogoImage from '../../../../images/default-logo.svg';

import './DefaultLogo.module.scss';

function DefaultLogo(props) {
  const { light } = props;
  const styleName = classNames('default-logo', { light });

  return <DefaultLogoImage styleName={styleName} />;
}

export default DefaultLogo;
